import { RESERVED_CONSOLE_PREFIXES } from "@sagot/constants";
import { useEffect } from "react";
import { useLocation, type RouteObject } from "react-router";
import { NotFoundPage } from "../pages/placeholder-pages";

/** True when this document itself was loaded at the current URL (the server sent the console shell). */
function loadedHere(href: string): boolean {
  const [entry] = performance.getEntriesByType("navigation");
  return entry?.name === href;
}

/**
 * DEC-040 reserved prefixes (`/admin`, `/chat`, `/widget.js`, `/v`, `/assets`) belong to other bundles on
 * the single origin. An in-app navigation there becomes a full page load; if the server answered
 * with the console shell anyway (e.g. the console dev server), show Not found instead of looping.
 */
export function LeaveConsole() {
  const location = useLocation();
  const href = window.location.href;
  const stay = loadedHere(href);
  useEffect(() => {
    if (!stay) window.location.replace(href);
  }, [href, stay, location.key]);
  return stay ? <NotFoundPage /> : null;
}

export const reservedPrefixRoutes: RouteObject[] = RESERVED_CONSOLE_PREFIXES.flatMap((prefix) => [
  { path: prefix, element: <LeaveConsole /> },
  { path: `${prefix}/*`, element: <LeaveConsole /> },
]);
